import { getApi } from 'api/axios';
import { useState } from 'react';

export const useDocumentApi = () => {
  const [loading, setLoading] = useState();
  const [documents, setDocuments] = useState();

  const getDocuments = async () => {
    try {
      setLoading(true);
      const { data } = await (
        await getApi({ baseUrl: window._env_.REACT_APP_QDAK_USER_URL })
      ).get(`/admin/users/current/contracts`);
      setDocuments(data);
      setLoading(false);
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  };

  const downloadDocument = async (contractId, name) => {
    try {
      setLoading(contractId);
      const { data } = await (
        await getApi({ baseUrl: window._env_.REACT_APP_QDAK_USER_URL })
      ).get(`/admin/users/current/contracts/${contractId}`, {
        headers: {
          'Content-Type': 'application/pdf'
        },
        responseType: 'blob'
      });
      setLoading(0);

      const href = window.URL.createObjectURL(new Blob([data], { type: 'application/pdf' }));

      const link = document.createElement('a');
      link.href = href;
      link.download = `${name}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(href);
    } catch (e) {
      setLoading(false);
      console.error(e);
    }
  };
  return {
    getDocuments,
    downloadDocument,
    loading,
    documents
  };
};
